import { render, staticRenderFns } from "./Rutes.vue?vue&type=template&id=12970b00&scoped=true&"
import script from "./Rutes.vue?vue&type=script&lang=js&"
export * from "./Rutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12970b00",
  null
  
)

export default component.exports